<!--
 * @Author: Nie Wie
 * @Date: 2020-01-09 13:42:25
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-31 13:18:38
 * @Description: 可修改为 switch 开关控件，
 * 使用时记得，开关事件通过绑定的 checked 方法
 -->
 <template>
  <div class="n-switch-check">
    <div :class="['n-switch-check__left', checked ? null : 'n-switch-check__active']"
      @click="openClose">
      <span>{{value1}}</span>
      <div v-show="!checked" class="n-switch-check__cicle-icon"></div>
    </div>
    <div :class="['n-switch-check__right', checked ? 'n-switch-check__active' : null]"
      @click="openClose">
      <div v-show="checked" class="n-switch-check__cicle-icon"></div>
      <span>{{value2}}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // checked: true, // 是否选中状态
    }
  },
  props: {
    value1: {
      type: String,
      default: '开',
    },
    value2: {
      type: String,
      default: '关',
    },
    checked: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 开关点击事件
    openClose() {
      // this.checked = !this.checked
      this.$emit('checkChange')
    },
  },
}
</script>

<style lang="scss" scoped>
$check-height: 40px;
.n-switch-check {
  width: 144px;
  height: $check-height;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  font-size:20px;
  font-weight:300;
  font-family:PingFangSC-Light,PingFang SC;
  color: #005EFF;
  background:rgba(241,245,255,1);
  border-radius:24px;
  border:1px solid rgba(204,222,255,1);
  .n-switch-check__left {
    display: flex;
    height: $check-height * 0.8;
    padding-left: 8px;
    justify-content: space-around;
    align-items: center;
    border-radius: 16px;
  }
  .n-switch-check__right {
    display: flex;
    height: $check-height * 0.8;
    padding-right: 8px;
    justify-content: space-around;
    align-items: center;
    border-radius: 16px;
  }
  .n-switch-check__active {
    background-color: #fff;
    color: #737373;
  }
  .n-switch-check__cicle-icon {
    width: 18px;
    height: 18px;
    margin: 0 5px;
    display: inline-block;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0px 1px 2px 0px rgba(0,94,255,0.5);
  }
  .n-switch-check__checked {
    padding: 3px 5px;
    width: 144px;
    display: flex;
    justify-content: space-between;
    border-radius: 15px;
    border: 1px solid #CCDEFF;
    border-radius: 15px;
    background-color: #CCDEFF;
    font-size:20px;
    font-family:PingFangSC-Light,PingFang SC;
    color: #737373;
    transform: translate(5px, -4px);
    cursor: pointer;
  }
}
</style>
